var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('button',{attrs:{"id":"skip"},on:{"click":_vm.skipVideo}},[_vm._v("Passer")])])}
var staticRenderFns = []

export { render, staticRenderFns }